<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
        }}</span>
        <span class="masge">当前共有{{ total }}条{{ this.route.menuName }}</span>
      </div>
      <div class="header">
        <div class="left">
          <!-- && !system_setting.isAutoSubmitOrderToPriceMonitor -->
          <el-button v-if="tableAcl.indexOf('Push') != -1" type="primary" class="btn primary" @click="push">确认上传</el-button>
          <el-button v-if="tableAcl.indexOf('Push') != -1" type="primary" class="btn primary" @click="pull">获取配送</el-button>

          <el-button v-if="tableAcl.indexOf('Export') != -1" type="primary" class="btn primary" @click="exportData" v-loading="exportButtonLoading" :disabled="exportButtonLoading">导出</el-button>
          <SelectFilter ref="selectFilter" :options="filterOptions" :query="query" @filterChange="filterChange" @reset="reset1"></SelectFilter>
        </div>
      </div>

      <el-table ref="multipleTable" border row-key="id" v-loading="loading" :data="tableData" :max-height="tableHeight" style="width: 100%" @selection-change="handleSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
        <template slot="empty">
          <div class="empty-div" :style="{ height: tableHeight + 'px' }">
            <img src="../../../../assets/noData.png" width="240" height="240" />
            <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
            <div class="empty-rest" @click="reset1">恢复默认</div>
          </div>
        </template>
        <el-table-column fixed :reserve-selection="true" prop="selection" type="selection" width="55" align="center"></el-table-column>
        <el-table-column fixed type="index" width="55" align="center"></el-table-column>
        <el-table-column prop="priceMonitorHospitalId" width="120" label="医院编号" show-overflow-tooltip></el-table-column>
        <el-table-column prop="no" width="170" label="院入库单" show-overflow-tooltip></el-table-column>
        <el-table-column prop="purchaseOrderNo" width="170" label="院采购单号" show-overflow-tooltip></el-table-column>
        <el-table-column prop="distributionNo" width="170" label="院验收单号" show-overflow-tooltip></el-table-column>
        <el-table-column prop="pmGoodsId" width="170" label="平台产品Id" show-overflow-tooltip></el-table-column>

        <el-table-column prop="supplierProductNo" width="140" show-overflow-tooltip label="院目录编码"></el-table-column>
        <el-table-column prop="productName" width="120" label="院产品名称" show-overflow-tooltip></el-table-column>
        <el-table-column prop="specName" width="120" label="院规格型号" show-overflow-tooltip></el-table-column>
        <el-table-column prop="priceMonitorReagentCompanyIdPs" width="140" label="配送企业编码" show-overflow-tooltip></el-table-column>
        <el-table-column prop="supplierName" width="120" label="配送企业名称" show-overflow-tooltip></el-table-column>
        <el-table-column prop="minUnit" width="100" label="院最小单位" show-overflow-tooltip></el-table-column>
        <el-table-column prop="price" width="100" label="院入库单价" show-overflow-tooltip></el-table-column>
        <el-table-column prop="number" width="120" label="院入库数量"></el-table-column>
        <el-table-column prop="amount" width="100" label="院入库金额" show-overflow-tooltip></el-table-column>
        <el-table-column prop="manufacturerName" width="120" label="院生产厂家" show-overflow-tooltip></el-table-column>
        <el-table-column prop="productRegistCertNo" width="120" label="院注册证号" show-overflow-tooltip></el-table-column>
        <el-table-column prop="batch" width="170" label="批号" show-overflow-tooltip></el-table-column>
        <el-table-column prop="validityDate" label="有效期" width="100">
          <template slot-scope="scope">
            {{
              scope.row.validityDate
                ? parseTime(new Date(scope.row.validityDate), "{y}-{m}-{d}")
                : ""
            }}
          </template>
        </el-table-column>
        <el-table-column prop="manufactureDate" label="生产日期" width="100">
          <template slot-scope="scope">
            {{
              scope.row.manufactureDate
                ? parseTime(new Date(scope.row.manufactureDate), "{y}-{m}-{d}")
                : ""
            }}
          </template>
        </el-table-column>
        <el-table-column prop="createdTime" width="150" label="创建时间" show-overflow-tooltip>
          <template slot-scope="scope">{{
            parseTime(new Date(scope.row.createdTime))
          }}</template>
        </el-table-column>
        <el-table-column prop="createdUserName" width="80" label="创建人"></el-table-column>
        <el-table-column prop="detailId" width="140" show-overflow-tooltip label="院采购明细编号"></el-table-column>
        <el-table-column prop="priceMonitorDistributeId" width="140" label="平台配送明细编号" show-overflow-tooltip></el-table-column>
        <el-table-column prop="detailRemark" width="170" label="备注" show-overflow-tooltip></el-table-column>
        <el-table-column prop="priceMonitorStateName" width="100" label="数据状态" show-overflow-tooltip></el-table-column>
        <el-table-column prop="supplierProductCompareStateName" width="100" label="对照状态" show-overflow-tooltip></el-table-column>
        <el-table-column fixed="right" prop="priceStateName" width="100" label="价格状态" show-overflow-tooltip>
          <template slot-scope="scope"><span :class="{
                enable: scope.row.priceState == 1,
                forbidden: scope.row.priceState == 0,
              }">{{ scope.row.priceStateName }}</span></template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <el-pagination background layout="sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange" :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {
  GetPurchaseInStockDetails,
  PushPurchaseInStockDetails,
  ExportPriceMonitorPurchaseInStock,
  GetSjDistributesByOrderDetailId
} from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
import BaseListMixin from "@/mixin/baseList-mixin.js";
import {
  PriceMonitorOrderTypeOptions,
  PriceMonitorPushStateOptions,
  PriceMonitorCompareStateOptions,
  PriceMonitorPriceStateOptions,
  PriceMonitorOrderStateOptions,
} from "@/enum";
import SelectFilter from "@/components/table-select-filter";

export default {
  mixins: [GetDataMixin, GetDataSpdMixin, BaseListMixin],
  components: {
    SelectFilter,
  },
  data () {
    return {
      GetDatasAction: GetPurchaseInStockDetails,
      exportAction: ExportPriceMonitorPurchaseInStock,

      PriceMonitorOrderTypeOptions: PriceMonitorOrderTypeOptions,
      PriceMonitorPriceStateOptions: PriceMonitorPriceStateOptions,
      PriceMonitorCompareStateOptions: PriceMonitorCompareStateOptions,
      PriceMonitorPushStateOptions: PriceMonitorPushStateOptions,
      PriceMonitorOrderStateOptions: PriceMonitorOrderStateOptions,
      // 批号；数据状态（下拉框：已上传、未上传）；院入库单价；院采购单；院注册证号；创建时间（默认取值近7天）；价格状态；目录对照状态（下拉框：已对照；未对照。默认值是已对照）
      filterOptions: [{
        name: "院入库单",
        type: "input",
        code: "keyWord",
      },
      {
        name: "院验收单号",
        type: "input",
        code: "purchaseDistributionNo",
      },
      {
        name: "平台产品ID",
        type: "input",
        code: "goodsId",
      },
      {
        name: "院目录编码",
        type: "input",
        code: "supplierProductNo",
      },
      {
        name: "院产品名称",
        type: "input",
        code: "productName",
      },
      {
        name: "院规格型号",
        type: "input",
        code: "specName",
      },
      {
        name: "配送企业编码",
        type: "input",
        code: "companyIdPs",
      },
      {
        name: "配送企业名称",
        type: "input",
        code: "companyName",
      },
      {
        name: "院生产厂家",
        type: "input",
        code: "manufacturerName",
      },
      {
        name: "批号",
        type: "input",
        code: "batch",
      },
      {
        name: "数据状态",
        type: "select",
        code: "state",
        data: PriceMonitorPushStateOptions,
      },
      {
        name: "院采购单",
        type: "input",
        code: "purchaseOrderNo",
      },
      {
        name: "院注册证号",
        type: "input",
        code: "productRegistCertNo",
      },
      {
        name: "院入库单价",
        type: "number",
        code: "price",
      },
      {
        name: "价格状态",
        type: "select",
        code: "priceState",
        data: PriceMonitorPriceStateOptions,
      },
      {
        name: "目录对照状态",
        type: "select",
        code: "supplierProductCompareState",
        data: PriceMonitorCompareStateOptions,
        defaultValue: 1,
      },
      {
        name: "创建时间",
        type: "date",
        code: "date",
        defaultValue: this.getDefaultDateRange(), // [new Date(new Date().setDate(new Date().getDate() - 7)), new Date()],//],
        startDateCode: "startDate",
        endDateCode: "endDate",
      },
      {
        name: "是否已配送",
        type: "select",
        code: "isDistribution",
        data: [{
          id: 0,
          name: "否"
        },
        {
          id: 1,
          name: "是"
        },
        ],
      },
      ],
    };
  },
  methods: {
    getDefaultDateRange () {
      var endDate = new Date();
      var start = new Date(new Date().setDate(new Date().getDate() - 6));
      // 开始日期转换为00:00:00
      var startDate = new Date(
        `${start.getFullYear()}-${start.getMonth() + 1}-${start.getDate()} 00:00:00`
      );

      return [startDate, endDate];
    },

    pull () {
      if (!this.ids || this.ids.length == 0) {
        this.$my_message("请选择要获取的订单配送数据", "warning");
        return;
      }
      // var pushedList = this.multipleSelection.filter((e) => e.priceMonitorState == 0);
      // if (pushedList && pushedList.length > 0) {
      //     this.$my_message("请选择已上传的订单数据", "warning");
      //     return;
      // }
      if (this.ids.length > 10) {
        this.$my_message("一次最大获取10条配送信息", "warning");
        return;
      }
      // var orderDetailStates = this.multipleSelection.filter(
      //   (e) => [4, 7, 8].indexOf(e.priceMonitorOrderDetailState) == -1
      // );
      // filter(e => !(e.priceMonitorOrderDetailState == 4 || e.priceMonitorOrderDetailState == 7 || e.priceMonitorOrderDetailState == 8))
      // if (orderDetailStates && orderDetailStates.length > 0) {
      //   this.$my_message("请选择已配送待收货|收货中|已收货的数据", "warning");
      //   return;
      // }

      // let priceMonitorDetailIds = this.multipleSelection.map((item) => item.priceMonitorOrderDetailId);
      let nos = this.multipleSelection.map((item) => item.no);
      let ids = []
      this.tableData.forEach(item => {
        if (nos.indexOf(item.no) != -1) {
          ids.push(item.priceMonitorOrderDetailId);
        }
      })
      // console.log(ids)

      GetSjDistributesByOrderDetailId({ ids: ids }).then((res) => {
        if (res.successful) {
          this.$my_message(`提交成功`, "success");
          this.getData()
        }
      });
    },
    push () {
      if (!this.multipleSelection || this.multipleSelection.length == 0) {
        this.$my_message("请选择要上传的入库明细数据", "warning");
        return;
      }

      var pushedList = this.multipleSelection.filter((e) => e.priceMonitorState == 1);
      if (pushedList && pushedList.length > 0) {
        this.$my_message("请选择要未上传的入库明细数据", "warning");
        return;
      }

      // 未对照的不能上传
      let notCompareList = this.multipleSelection.filter(
        (item) => item.supplierProductCompareState != 1
      );
      if (notCompareList && notCompareList.length > 0) {
        this.$my_message(
          `所选入库单明细中包含供货目录未对照的明细，请对照后再上传`,
          "warning"
        );
        // this.$my_message(`所选医院验收入库单号${notCompareList[0].no}存在价格异常，请核对后确认是否上传`, 'warning');
        return;
      }

      // 价格异常的提示
      let priceExceptionList = this.multipleSelection.filter(
        (item) => item.priceState != 1
      );
      if (priceExceptionList && priceExceptionList.length > 0) {
        const h = this.$createElement;
        let content = [h("p", "以下所选入库单明细存在价格异常")];
        priceExceptionList.forEach((item) => {
          content.push(h("p", {
            style: "color:red"
          }, `${item.no}`));
        });
        content.push(h("p", "请核对后确认是否上传"));
        this.$confirm("提示", {
          title: "提示",
          type: "warning",
          message: h("div", content),
        }).then(() => {
          // 上传数据
          this.pushOrder();
        });
      } else {
        this.pushOrder();
      }
    },
    pushOrder () {
      let ids = this.multipleSelection.map((item) => item.detailId);
      PushPurchaseInStockDetails({
        ids: ids
      }).then((res) => {
        this.$my_message("上传成功", "success");
        this.getData();
      });
    },

    // 重置
    reset1 () {
      this.query.keyWord = ''
         this.query.pageSize = 10
          this.query.pageIndex = 1
          this.query.priceMonitorType = 0
          this.query.isDistribution = 1
      if (this.$refs["selectFilter"]) {
        this.$refs["selectFilter"].resetQuery();
      }
      this.ids = [];
      this.multipleSelection = [];

      if (this.$refs.multipleTable) {
        this.$refs.multipleTable.clearSelection();
      }
      this.loading = true;
      this.getData();
    },
  },
  mounted () { },
  created () {
    var dateArr = this.getDefaultDateRange();
    this.query.startDate = this.parseTime(dateArr[0]);
    this.query.endDate = this.parseTime(dateArr[1]);
    this.query.priceMonitorType = 1;
    this.query.isDistribution = 1;

  },
};
</script>

<style lang="scss" scoped></style>
